import React from "react";
import type { EmptyStateModel } from "../../type/empty";
import "./emptyState.scss";


const EmptyState: React.FC<EmptyStateModel> = ({
  icon,
  title,
  description,
  button,
  className = '',
}) => {
  return (
    <div className={`empty-state ${className}`}>
      <i className={`${icon} display-1 text-muted`}></i>
      <h4 className="mt-3">{title}</h4>
      <p className="text-muted">{description}</p>
      {button && (
        <button
          className={`btn btn-${button.variant || 'primary'} mt-3`}
          onClick={button.onClick}
        >
          {button.icon && <i className={`${button.icon} me-2`}></i>}
          {button.label}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
